import { InputForm, SubmitButton } from "components";
import {
    DateRangeInputError,
} from "modules/user_management/dcdd_user/users/state/actionType";
import { DcddTotalUserDataInput } from "../../state/actionType";
import { useSelector } from "react-redux";
import SelectForm from '../../../../../components/form/SelectForm';
import { GenericProps } from '../../../../user_management/dcdd_user/users/state/actionType';
import { DcddRegistrationCategory } from '../../../../../props/enum';
import { fetchDzongkhag, fetchEccd, fetchSchools } from "modules/user_management/dcdd_user/users/state/action";
import { useEffect } from "react";

interface DataProps {
    formData: DcddTotalUserDataInput;
    error: DateRangeInputError;
    loading: boolean;
    dzongkhagData?: GenericProps[];
    eccdData?: GenericProps[];
    schoolData?: GenericProps[];
    onClose?: () => void;
    handleChange: (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => void;
    handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & DataProps;
const DateRangeForm: React.FC<Props> = ({
    handleChange,
    handleSubmit,
    error,
    formData,
    loading,
    onFetchDzongkhag,
    onFetchSchools,
    onFetchEccd,
}) => {
    const dzongkhagData = useSelector((state: any) => state?.dcddUser.dcddUserState?.fetchDzongkhag);
    const schoolData = useSelector((state: any) => state?.dcddUser.dcddUserState?.fetchSchool);
    const eccdData = useSelector((state: any) => state?.dcddUser.dcddUserState?.fetchEccd);
    useEffect(() => {
        onFetchDzongkhag();
    }, [onFetchDzongkhag]);
    useEffect(() => {
        if (formData.dzongkhag_id) {
            onFetchEccd(formData.dzongkhag_id);
            onFetchSchools(formData.dzongkhag_id);
        }
    }, [formData.dzongkhag_id, onFetchEccd, onFetchSchools]);


    return (
        <form>
            <div className="flex gap-4 items-end">
                {/* From Date */}
                <div>
                    <InputForm
                        label="From Date"
                        id="from_date"
                        name="from_date"
                        type="date"
                        value={formData.from_date ?? ""}
                        onChange={handleChange}
                    />
                    {/* {error.fromDate && <Error>{error.fromDate}</Error>} */}
                </div>
                {/* To Date */}
                <div>
                    <InputForm
                        label="To Date"
                        id="to_date"
                        name="to_date"
                        type="date"
                        value={formData.to_date ?? ""}
                        onChange={handleChange}
                    />
                    {/* {error.toDate && <Error>{error.toDate}</Error>} */}
                </div>
                <div>
                    <SelectForm
                        styleLabel="text-sm/6 font-medium"
                        label="Category"
                        type="text"
                        id="category"
                        name="category"
                        value={formData?.category ?? ""}
                        option={Object.values(DcddRegistrationCategory).map((value) => (
                            <option key={value} value={value}>
                                {value}
                            </option>
                        ))}
                        onChange={handleChange}
                    />
                    {/* {error?.category && <Error>{error?.category}</Error>} */}
                </div>
                <div>
                    <SelectForm
                        type="text"
                        styleLabel="text-sm/6 font-medium"
                        label="Dzongkhag"
                        id="dzongkhag_id"
                        name="dzongkhag_id"
                        value={formData.dzongkhag_id ?? ""}
                        option={dzongkhagData?.map((dzongkhag: GenericProps) => (
                            <option
                                key={dzongkhag.id.toString()}
                                value={dzongkhag.id.toString()}
                            >
                                {dzongkhag.name}
                            </option>
                        ))}
                        onChange={handleChange}
                    />
                    {/* {error.dzongkhag_id && <Error>{error.dzongkhag_id}</Error>} */}
                </div>
                {formData.category === DcddRegistrationCategory.DZONGKHA_TEACHER || formData.category === DcddRegistrationCategory.STUDENT ? (
                    <div>
                    <SelectForm
                        type="text"
                        styleLabel="text-sm/6 font-medium"
                        label="School"
                        id="school_id"
                        name="school_id"
                        value={formData.school_id ?? ""}
                        option={schoolData?.map((school: GenericProps) => (
                            <option key={school.id.toString()} value={school.id.toString()}>
                                {school.name}
                            </option>
                        ))}
                        onChange={handleChange}
                    />
                    {/* {error.school_id && <Error>{error.school_id}</Error>} */}
                </div>
                ): null}
                {formData.category === DcddRegistrationCategory.ECCD_FACILITATOR || formData.category === DcddRegistrationCategory.ECCD? (
                    <div>
                    <SelectForm
                        type="text"
                        styleLabel="text-sm/6 font-medium"
                        label="ECDD"
                        id="eccd_id"
                        name="eccd_id"
                        value={formData.eccd_id ?? ""}
                        option={eccdData?.map((eccd: GenericProps) => (
                            <option key={eccd.id.toString()} value={eccd.id.toString()}>
                                {eccd.name}
                            </option>
                        ))}
                        onChange={handleChange}
                    />
                </div>
                ): null}
                {/* Submit Button */}
                <div className="pb-3">
                    <SubmitButton
                        onClick={handleSubmit}
                        loading={loading}
                        loadingText="Searching..."
                    >
                        Search
                    </SubmitButton>
                </div>

            </div>
        </form>
    );
};

const mapStateToProps = (state: any) => ({
    fetchDcddState: state.dcddUser.dcddUserState,
});

const mapDispatchToProps = (dispatch: any) => ({
    onFetchDzongkhag: () => dispatch(fetchDzongkhag()),
    onFetchSchools: (dzongkhag_id: string) =>
        dispatch(fetchSchools(dzongkhag_id)),
    onFetchEccd: (dzongkhag_id: string) => dispatch(fetchEccd(dzongkhag_id)),
});


export default DateRangeForm;
